import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.esm.js";
import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import "@fancyapps/ui/dist/carousel/carousel.autoplay.css";

function InitCarousel(){

    let elements = document.querySelectorAll( ".carousel.f-carousel" );

    if( elements ){
        elements.forEach( item => {
                new Carousel(
                    item ,
                    {
                        infinite : true ,
                        Dots : {
                            maxCount : 0
                        } ,
                        Autoplay : {
                            timeout : 3000 ,
                            autoStart : true ,
                            showProgress : false
                        } ,
                    } ,
                    {
                        Autoplay
                    }
                );
            }
        );
    }
}

document.addEventListener( "DOMContentLoaded" , InitCarousel );
